<template>
  <span class="switch" @click="toggle">
    <input type="checkbox" role="switch" :id="formField.id" ref="inputRef" v-model="model" v-bind="$attrs" />
    <span class="slider round"></span>
  </span>
</template>

<script setup lang="ts">
import { inject, ref, useAttrs } from 'vue';

import { FORM_FIELD_TOKEN } from './form-field/form-field.token';

const attrs = useAttrs();
const model = defineModel();
const inputRef = ref<HTMLInputElement>();
const formField = inject(FORM_FIELD_TOKEN, { id: attrs.id as string });

function toggle() {
  inputRef.value?.click();
}
</script>

<style scoped lang="scss">
.switch {
  --animation-duration: 300ms;
  position: relative;
  display: inline-block;
  width: 2.75rem;
  height: 1.625rem;

  &:hover:has(:not(input:disabled)) {
    cursor: pointer;
  }
}

.switch input {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  outline: 0;
}

.slider {
  --height: 1.625rem;

  width: 2.75rem;
  height: var(--height);
  display: block;
  background-color: var(--t-color-neutral-300);
  transition: var(--animation-duration);
  border-radius: calc(var(--height) / 2);
}

.slider:before {
  content: '';
  position: absolute;
  left: 0.125rem;
  bottom: 0.11rem;
  background-color: white;
  transition: var(--animation-duration);
  width: 1.4rem;
  height: 1.4rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2);
  border-radius: var(--t-border-radius-full-rounded);
}

input:checked + .slider {
  background-color: var(--t-color-neutral-800);
}

input:checked + .slider:before {
  transform: translateX(1.1rem);
}
</style>
